var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-card-illustration d-none d-lg-flex flex-column w-100 p-5"},[_c('img',{attrs:{"alt":"Logo","src":"/img/logo.svg","width":"300"}}),_vm._v(" "),(_vm.title)?_c('h3',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }